import { Gql } from '@fiverr-private/dynamic_matching';
import { getContext } from '@fiverr-private/fiverr_context';
import { useBriefCreationContext } from '../../context/BriefCreationContext';
import type { BudgetAndTimelineContent } from '../Sections/BudgetAndTimeline/utils';
import { convertDollarToCents } from '../../utils';
import { isFromMobileAppByQueryParam } from '../../utils/isFromMobileAppByQueryParam';
import { hasAttemptedMigrationRecently } from './utils';

const BUDGET_SECTION_ID = 'budget_and_timeline';
const NOT_PRO_MIGRATION_ELIGIBILITY = {
    isEligibleForProMigration: false,
    isHourly: false,
    isHighBudget: false,
    isVeryHighBudget: false,
};

export const useIsEligibleForProMigration = () => {
    const { organizationId } = getContext();
    const { brief, rollouts } = useBriefCreationContext();
    const budgetSection = brief?.sections.find((section) => section.id === BUDGET_SECTION_ID);

    if (!budgetSection || hasAttemptedMigrationRecently()) {
        return NOT_PRO_MIGRATION_ELIGIBILITY;
    }

    const { budgetInCents, pricingType } = budgetSection.content as unknown as BudgetAndTimelineContent;

    if (!budgetInCents) {
        return NOT_PRO_MIGRATION_ELIGIBILITY;
    }

    const isFromMobileApp = isFromMobileAppByQueryParam();

    if (isFromMobileApp) {
        return NOT_PRO_MIGRATION_ELIGIBILITY;
    }

    const budget200To999 = budgetInCents >= convertDollarToCents(200) && budgetInCents <= convertDollarToCents(999);
    const budget1000AndMore = budgetInCents >= convertDollarToCents(1000);

    const isHourly = pricingType === Gql.BriefPricingType.Hourly;
    const isHighBudget = !isHourly && budget200To999;
    const isVeryHighBudget = !isHourly && budget1000AndMore;

    return {
        isEligibleForProMigration:
            rollouts?.inDolphinsJobPostMigration && !organizationId && (isHourly || isHighBudget || isVeryHighBudget),
        isHourly,
        isHighBudget,
        isVeryHighBudget,
    };
};
